import React, { useContext } from 'react';
import classNames from 'classnames';
import { Context } from '../../context/AppContext';
import CustomTag from '../CustomTag';
import './styles.css';

const RoundButton = ({
  disabled,
  activeDisabled,
  theme,
  children,
  icon,
  size,
  className,
  hoverIcon,
  tag = 'button',
  iconPosition = 'left',
  ...props
}) => {
  const {
    media: { mobile },
  } = useContext(Context);
  return (
    <CustomTag
      className={classNames('RoundButton__root', {
        'RoundButton__root--disabled': disabled,
        'RoundButton__root--activeDisabled': activeDisabled,
        'RoundButton__root--mobile': mobile,
        'RoundButton__root--hasIcon': icon,
        'RoundButton__root--hoverIcon': hoverIcon,
        [`RoundButton__root--${theme}`]: theme,
        [`RoundButton__root--${size}`]: size,
        [className]: className,
      })}
      disabled={disabled}
      tag={tag}
      {...props}
    >
      {icon && iconPosition === 'left' && (
        <span className="RoundButton__icon">{icon}</span>
      )}
      {children}
      {icon && iconPosition === 'right' && (
        <span className="RoundButton__icon RoundButton__icon--right">
          {icon}
        </span>
      )}
      {hoverIcon && <i className={`RoundButton__hoverIcon ${hoverIcon}`} />}
    </CustomTag>
  );
};

export default RoundButton;
